import { RadioCardGroup } from '@/shared/ui/RadioCardGroup';
import { useVisibilityOptions } from './useVisibilityOptions';
import type { SpaceVisibilityFieldProps } from './SpaceVisibilityField.types';

export function SpaceVisibilityField(props: SpaceVisibilityFieldProps) {
  const {
    isOrganizationAdmin,
    organizationName,
    workspaceName,
    canSelectWorkspaces,
    includeCurrentWorkspace,
    ...fieldProps
  } = props;
  const options = useVisibilityOptions({
    isOrganizationAdmin,
    organizationName,
    workspaceName,
    canSelectWorkspaces,
    includeCurrentWorkspace,
    currentValue: fieldProps.value,
  });

  return <RadioCardGroup {...fieldProps} options={options} />;
}
